import { useMemo, useEffect } from 'react';
import { getEmotionResetStyles } from './EmotionResetStyles.js';
import { Global } from '@emotion/react';
import { jsx } from '@emotion/react/jsx-runtime';

const RESET_STYLES_CLASS = 'giger-emotion-reset';
const EmotionReset = _ref => {
  let {
    reference,
    scope,
    emotionCacheShadowRootContainer
  } = _ref;
  const resetScope = useMemo(() => scope || RESET_STYLES_CLASS, [scope]);
  useEffect(() => {
    if (reference && !scope) {
      reference.classList.add(resetScope);
    }
  }, [reference, resetScope, scope]);
  const styles = useMemo(() => getEmotionResetStyles(reference ? resetScope : undefined, emotionCacheShadowRootContainer), [reference, resetScope, emotionCacheShadowRootContainer]);
  return jsx(Global, {
    styles: styles
  });
};

export { EmotionReset };
//# sourceMappingURL=EmotionReset.js.map
